import { FulfillmentPlanOrderGridStatus } from '../../../../enums/fulfillmentplan-order-grid-status';

export const buildShipmentManifestData = (fulfillmentPlans) => {
  return fulfillmentPlans.reduce((acc, item) => {
    if (item.orderGridStatus === FulfillmentPlanOrderGridStatus.Shipped.name) {
      acc.push({ fulfillmentPlanId: item.fulfillmentPlanId });
    }
    return acc;
  }, []);
};
